console.log('Testing Script');

$('#custom-form').on('submit', function(e) {
    e.preventDefault();

    var formData = $(this).serialize();
    var webhookURL = 'https://script.google.com/macros/s/AKfycbx1E0WwqCrzp7tNrxYAbsVOazDbaiweD38oJrf8jQBLyrh22RROrNUZGO7j8-VNymOBEg/exec'; // replace with your script URL

    $.ajax({
      url: webhookURL,
      method: 'POST',
      data: formData,
      success: function(response) {
        $('#form-response').text("Thank you! Your message was sent.");
        $('#custom-form')[0].reset();
      },
      error: function(err) {
        $('#form-response').text("Oops! Something went wrong.");
      }
    });
  });


// $(document).ready(function () {
//   $('.newletter_email form').on('submit', function (e) {
//     e.preventDefault(); // Stop the form temporarily

//     const $form = $(this);
//     const action = $form.attr('action'); // original action URL
//     const method = $form.attr('method') || 'POST';

//     const formData = $form.serialize(); // get all field data

//     const scriptURL = 'https://script.google.com/macros/s/AKfycbxrGwkS1VeicbKi_KVBc-EY-FMbvR2IEeg2jMkj1dhpL73Yptwlwt6X6YJ8u_Gz2xJXHA/exec'; // your Google Apps Script URL

//     // Submit to Google Sheet
//     $.ajax({
//       url: scriptURL,
//       method: 'POST',
//       data: formData,
//       success: function () {
//         // After successful Google Sheet submission, continue to submit the original form
//         const tempForm = $('<form>')
//           .attr('method', method)
//           .attr('action', action)
//           .hide();

//         // Add hidden inputs with form data
//         $form.serializeArray().forEach(function (item) {
//           $('<input>')
//             .attr('type', 'hidden')
//             .attr('name', item.name)
//             .attr('value', item.value)
//             .appendTo(tempForm);
//         });

//         // Append and submit
//         $('body').append(tempForm);
//         tempForm.submit();
//       },
//       error: function () {
//         alert("Error submitting to Google Sheet.");
//         // Optionally still allow original form to submit even if Sheets fails
//         $form.off('submit').submit(); 
//       }
//     });
//   });
// });


// $(document).ready(function () {
//   $('#contact_form').on('submit', function (e) {
//     e.preventDefault(); // Stop normal submission

//     const $form = $(this);
//     const action = $form.attr('action');
//     const method = $form.attr('method');

//     const formDataArray = $form.serializeArray();
//     const dataToSend = {
//       name: '',
//       email: '',
//       message: ''
//     };

//     // Extract actual values
//     formDataArray.forEach(function (field) {
//       if (field.name === 'contact[name]') dataToSend.name = field.value;
//       if (field.name === 'contact[email]') dataToSend.email = field.value;
//       if (field.name === 'contact[Message]') dataToSend.message = field.value;
//     });

//     const scriptURL = 'https://script.google.com/macros/s/AKfycbx1E0WwqCrzp7tNrxYAbsVOazDbaiweD38oJrf8jQBLyrh22RROrNUZGO7j8-VNymOBEg/exec'; // your Google Apps Script URL

//     // Send to Google Sheets first
//     $.ajax({
//       url: scriptURL,
//       method: 'POST',
//       data: dataToSend,
//       success: function () {
//         // After Sheets, re-submit original form to Shopify
//         const tempForm = $('<form>')
//           .attr('method', method)
//           .attr('action', action)
//           .hide();

//         formDataArray.forEach(function (item) {
//           $('<input>')
//             .attr('type', 'hidden')
//             .attr('name', item.name)
//             .attr('value', item.value)
//             .appendTo(tempForm);
//         });

//         $('body').append(tempForm);
//         tempForm.submit();
//       },
//       error: function () {
//         alert('Failed to send to Google Sheet. Submitting anyway.');
//         $form.off('submit').submit(); // fallback to default submit
//       }
//     });
//   });
// });


$(document).ready(function () {
  $('.box-email .contact-form').on('submit', function () {
    // let Shopify handle the real submission (don't preventDefault)

    const $form = $(this);
    const formDataArray = $form.serializeArray();
    const dataToSend = {
      name: '',
      email: '',
      phone: '',
      message: ''
    };

    formDataArray.forEach(function (field) {
      if (field.name === 'contact[name]') dataToSend.name = field.value;
      if (field.name === 'contact[email]') dataToSend.email = field.value;
      if (field.name === 'contact[phone]') dataToSend.phone = field.value;
      if (field.name === 'contact[Message]') dataToSend.message = field.value;
    });
    console.log(dataToSend);
    // Google Sheets script URL
    const scriptURL = 'https://script.google.com/macros/s/AKfycbxuRl7r7UxLjaeIvGjeJxFwZkVQeXtoY-INOO5iidbktbyMDykP23Mghff_TJwsFBfpkA/exec';

    // Send to Google Sheets without blocking original submit
    $.ajax({
      url: scriptURL,
      method: 'POST',
      data: dataToSend
    });

    // allow form to continue submitting to Shopify
  });
});

$(document).ready(function () {
  $('#discountPopup .contact-form').on('submit', function () {
    // let Shopify handle the real submission (don't preventDefault)

    const $form = $(this);
    const formDataArray = $form.serializeArray();
    const dataToSend = {
      name: '',
      email: '',
      phone: '',
      message: ''
    };

    formDataArray.forEach(function (field) {
      if (field.name === 'contact[name]') dataToSend.name = field.value;
      if (field.name === 'contact[email]') dataToSend.email = field.value;
      if (field.name === 'contact[phone]') dataToSend.phone = field.value;
      if (field.name === 'contact[Message]') dataToSend.message = field.value;
    });
    console.log(dataToSend);
    // Google Sheets script URL
    const scriptURL = 'https://script.google.com/macros/s/AKfycbwwiqHsuAv8ce3p28a0Nv2khE4I5Fhib-o6Ph4VpnU5EVZ6G_9e1PZ81gtVI62uj-A2/exec';

    // Send to Google Sheets without blocking original submit
    $.ajax({
      url: scriptURL,
      method: 'POST',
      data: dataToSend
    });

    // allow form to continue submitting to Shopify
  });
});
function initVariantFix() {
  var radios = document.querySelectorAll('#AddToCartForm input[type="radio"]');
  var productSelect = document.querySelector('#productSelect');
  if (!radios.length || !productSelect) return false;

  function updateProductSelect() {
    var selectedOptions = [];
    var optionIndex = 0;
    while (true) {
      var checked = document.querySelector('#AddToCartForm input[name="option-' + optionIndex + '"]:checked');
      if (!checked) break;
      selectedOptions.push(checked.value);
      optionIndex++;
    }
    var title = selectedOptions.join(' / ');
    var variants = window.ShopifyAnalytics.meta.product.variants;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].public_title === title) {
        productSelect.value = variants[i].id;
        jQuery('#productSelect').val(variants[i].id).trigger('change');
        break;
      }
    }
  }

  radios.forEach(function(radio) {
    radio.addEventListener('change', updateProductSelect);
  });

  updateProductSelect();
  return true;
}

if (!initVariantFix()) {
  var observer = new MutationObserver(function(mutations, obs) {
    if (initVariantFix()) obs.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

